import { List } from "immutable"
import * as React from "react"
import { previousOrDefault } from "../../../../Shared/utils/asyncState"
import { Pager } from "../../../components/pager"
import { Jumbo } from "../../components/jumbo"
import { Teasers } from "../../components/teaser"
import { BlogOverviewLayoutProps, initialBlogResponse, resultsClass } from './blogOverviewState'

export const BlogOverviewLayout = (props: BlogOverviewLayoutProps) => {
  const { headerTitle, description, phImageUrl, phImageUrlLarge, imageAlt, blogpostLoader, blogCategoriesLoader, currentPage, pageSize, selectedCategory, setPage, setCategory, key } = props
  const { posts, totalResults } = previousOrDefault(blogpostLoader, initialBlogResponse)
  const categories = previousOrDefault(blogCategoriesLoader, [])

  const pager = totalResults
    ? Pager({ currentPage, pageSize, totalResults, setPage, containerSize: 'lg' })
    : <></>

  return (
    <React.Fragment key={key}>
      <Jumbo
        title={headerTitle}
        contents={description}
        imageUrl={phImageUrl}
        imageUrlLarge={phImageUrlLarge}
        imageAlt={imageAlt}
        size="small"
      />
      <div className="container--lg align--center">
        <section className={resultsClass}>
          <div className="overview-filter">
            <ul className="overview-filter__list">
              {categories.map((category) =>
                <li className="overview-filter__item" key={`blogs_filter_item_${category.slug}`}>
                  <button
                    className={`overview-filter__link button ${selectedCategory == category.slug ? 'button--active' : ''}`}
                    onClick={() => setCategory(category)}
                  ><span className="button__label">{category.name}</span></button>
                </li>
              )}
            </ul>
          </div>

          {posts.length > 0
            ? <Teasers items={List(posts)} />
            : <div className="text--styled">
              <p className="weight--bold container--s">
                Op dit moment zijn er helaas geen blogs beschikbaar.
              </p>
            </div>
          }
        </section>
      </div>

      {pager}
    </React.Fragment>
  )
}
